import React, { useEffect, useState, useRef } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";

const API_PDF_URL = process.env.REACT_APP_API_PDF_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;


const PoliciesCodes = () => {
  const pageid = 3; // 👈 set your backend pageid for Policies & Codes
  const sectionRefs = useRef({});
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch data
  useEffect(() => {
    const fetchPolicies = async () => {
      try {
        const response = await fetch(`${BASE_URL}?pageid=${pageid}`);
        if (!response.ok) throw new Error(`HTTP error! ${response.status}`);
        const result = await response.json();

        if (!result.success || !Array.isArray(result.data)) {
          setPolicies([]);
          setLoading(false);
          return;
        }

        // Group by title_name
        const grouped = {};
        result.data.forEach((item) => {
          const section = item.title_name || "Other Policies";
          if (!grouped[section]) grouped[section] = [];
          grouped[section].push({
            label: item.pdf_name,
            file: item.upload_file_path,
          });
        });

        const finalData = Object.keys(grouped).map((title) => ({
          title,
          items: grouped[title],
        }));

        setPolicies(finalData);
      } catch (error) {
        console.error("Fetch failed:", error);
        setPolicies([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPolicies();
  }, [BASE_URL, pageid]);

  // Auto scroll to first section
  useEffect(() => {
    if (policies.length > 0) {
      const el = sectionRefs.current[policies[0].title];
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  }, [policies]);

  return (
    <>
      <Helmet>
        <title>Policies & Codes | Nandan Denim Ltd.</title>
      </Helmet>
      <Header />

      {/* Hero Section */}
      <div className="relative w-full">
        <img
          src="./imgs/investors/investorpolicescodes.png"
          alt="Investor Policies and Codes"
          className="object-cover w-full h-full md:h-[70vh] lg:h-[80vh] xl:h-[88vh]"
        />
        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center">
          <div className="px-4 sm:px-8 md:px-16 lg:px-32">
            <h1 className="text-yellow-400 text-3xl sm:text-5xl md:text-7xl font-montserrat font-bold text-left">
              Policies & Codes
            </h1>
          </div>
        </div>
      </div>

      {/* Policies Sections */}
      <div className="py-12 px-4 font-signika max-w-7xl mx-auto">
        {loading ? (
          <p>Loading policies...</p>
        ) : policies.length === 0 ? (
          <p>No policies found.</p>
        ) : (
          policies.map((section, index) => (
            <div
              key={index}
              ref={(el) => (sectionRefs.current[section.title] = el)}
              className="mb-12"
            >
              <h2 className="text-xl font-extrabold text-[#0b3a6a] mb-4">
                {section.title}
              </h2>
              {section.items.length === 0 ? (
                <p>No files available.</p>
              ) : (
                <ul className="list-disc pl-6 space-y-2 text-[#0b3a6a]">
                  {section.items.map((item, idx) => (
                    <li key={idx}>
                      {item.file ? (
                        <a
                          href={`${API_PDF_URL}/${item.file}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hover:underline"
                        >
                          {item.label}
                        </a>
                      ) : (
                        <span className="text-gray-500">{item.label} (No file)</span>
                      )}
                    </li>
                  ))}
                </ul>
              )}
              {index < policies.length - 1 && (
                <hr className="mt-6 border-gray-300" />
              )}
            </div>
          ))
        )}
      </div>

      <Footer />
    </>
  );
};

export default PoliciesCodes;
